<template>
  <v-btn
    v-if="$abilities.includes('update shipments')"
    color="primary"
    small
    :disabled="!$route.query.batch"
    @click="cancelBatch"
  >
    Close batch
    <v-icon dark right> mdi-collapse-all </v-icon>
  </v-btn>
</template>
<script>
export default {
  name: "BatchCancelButton",
  methods: {
    cancelBatch: function () {
      this.$models.Batch.update(this.$route.query.batch, {
        deletedAt: new Date().toISOString(),
      })
        .then(() => {
          this.$bus.$emit("batchCanceled", this.$route.query.batch);
          // Was only clearSelectedOrders (OrdersView, not mounted here), so the
          // closed batch's shipments stayed selected for the next batch.
          this.$bus.$emit("clearSelectedShipments");
          this.$bus.$emit("clearSelectedOrders");
          this.$router.push({ name: "Home" });
        })
        .catch((e) => this.$bus.$emit("Error", e));
    },
  },
};
</script>
